var _excluded = ["onClick"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react-hooks/exhaustive-deps */
import { useCompositeItem } from "reakit";
import * as React from "react";
import { useLiveRef } from "reakit-utils/useLiveRef";
import { createHook } from "reakit-system/createHook";
import { createComponent } from "reakit-system/createComponent";
import { getItemId } from "./helpers";
import { SELECT_ITEM_KEYS } from "./__keys";
export var useSelectItem = createHook({
  name: "SelectItem",
  compose: useCompositeItem,
  keys: SELECT_ITEM_KEYS,

  useOptions(options) {
    var registerItem = React.useCallback(item => {
      var _options$registerItem;

      (_options$registerItem = options.registerItem) === null || _options$registerItem === void 0 ? void 0 : _options$registerItem.call(options, _objectSpread(_objectSpread({}, item), {}, {
        value: options.value
      }));
    }, [options.registerItem, options.value]);

    if (options.id || !options.baseId || !options.value) {
      return _objectSpread(_objectSpread({}, options), {}, {
        registerItem
      });
    }

    var id = getItemId(options.baseId, options.value, options.id);
    return _objectSpread(_objectSpread({}, options), {}, {
      registerItem,
      id
    });
  },

  useProps(options, _ref) {
    var {
      onClick: htmlOnClick
    } = _ref,
        htmlProps = _objectWithoutProperties(_ref, _excluded);

    var onClickRef = useLiveRef(htmlOnClick);
    var onClick = React.useCallback(event => {
      var _onClickRef$current, _options$setSelectedV, _options$hide;

      (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 ? void 0 : _onClickRef$current.call(onClickRef, event);
      if (event.defaultPrevented) return;
      if (!options.value) return;
      (_options$setSelectedV = options.setSelectedValue) === null || _options$setSelectedV === void 0 ? void 0 : _options$setSelectedV.call(options, options.value);
      (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
    }, [options.hide, options.value, options.setSelectedValue]);
    return _objectSpread({
      children: options.value,
      onClick
    }, htmlProps);
  }

});
export var SelectItem = createComponent({
  as: "span",
  memo: true,
  useHook: useSelectItem
});
//# sourceMappingURL=SelectItem.js.map